import moment from 'moment';

const parseIsoDurationToMinutes = (isoString) => {
  return moment.duration(isoString).asMinutes();
};

export default parseIsoDurationToMinutes;
